import {
  DifficultyEasyIcon,
  DifficultyHardIcon,
  DifficultyMediumIcon,
} from '../wag-react/next-components/icons';

export enum Difficulty {
  Easy = 'Easy',
  Medium = 'Medium',
  Hard = 'Hard',
}

export const DifficultyIconMap = {
  [Difficulty.Easy]: DifficultyEasyIcon,
  [Difficulty.Medium]: DifficultyMediumIcon,
  [Difficulty.Hard]: DifficultyHardIcon,
};
